/* tslint:disable */
/* eslint-disable */
/**
 * MWS.Platforms.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AdminDomainResponse {
    'id': string;
    'name': string;
    'platformId': string;
    'isFabricksDomain': boolean;
    'platform'?: AdminPlatformResponse | null;
    'configuration'?: AdminPlatformConfigurationResponse | null;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}
export interface AdminLimitedDomainResponse {
    'configuration'?: AdminListPlatformConfigurationResponse | null;
    'id': string;
    'name': string;
    'platformId': string;
    'configurationId': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}
export interface AdminListPlatformConfigurationResponse {
    'id': string;
    'platformId': string;
    'name': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}
export interface AdminListPlatformResponse {
    'id': string;
    'name': string;
    'isAuctionsEnabled': boolean;
    'isFramingSupported': boolean;
    'isFabricksEnabled': boolean;
    'onlyAutomaticallyPublishFixtureEvents': boolean;
    'isArchived': boolean;
    'domains': Array<LimitedDomainResponse>;
    'primaryDomain': LimitedDomainResponse;
    'redirects': Array<AdminRedirectResponse>;
    'partnerIds': Array<string>;
    'allowedOrigins': Array<string>;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}
export interface AdminPlatformConfigurationResponse {
    'id': string;
    'platformId': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'name': string;
    'definition': ConfigurationDefinition;
}
export interface AdminPlatformResponse {
    'id': string;
    'name': string;
    'isAuctionsEnabled': boolean;
    'isFramingSupported': boolean;
    'isFabricksEnabled': boolean;
    'onlyAutomaticallyPublishFixtureEvents': boolean;
    'isArchived': boolean;
    'webhookSettings'?: PlatformWebhookSettingsResponse | null;
    'trackingSettings'?: PlatformTrackingSettingsResponse | null;
    'domains': Array<AdminLimitedDomainResponse>;
    'primaryDomain': AdminLimitedDomainResponse;
    'redirects': Array<AdminRedirectResponse>;
    'partnerIds': Array<string>;
    'allowedOrigins': Array<string>;
    'cookieBotKey'?: string | null;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}
/**
 * http request response object for redirects (admin)
 */
export interface AdminRedirectResponse {
    'id': string;
    'platformId': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'active': boolean;
    'original': string;
    'redirect': string;
    'maxAge': number;
}
export interface AllowOriginRequest {
    'origin': string;
}
export interface Announcement {
    'label': { [key: string]: string; };
    'path'?: string | null;
}
export interface ApplicationPlatformResponse {
    'platformId': string;
    'platformName': string;
    'primaryDomain': string;
    'isAuctionsEnabled': boolean;
    'configurationId': string;
    'configurationName': string;
    'isFabricksEnabled': boolean;
    'cookieBotKey'?: string | null;
    'tracking': TrackingSettingsResponse;
    'styling': Styling;
    'assets': Assets;
    'header': Header;
    'footer': Footer;
    'pages': Array<Page>;
    'properties': Properties;
    'configurationDefaultHead': Head;
}
export interface Assets {
    'primaryLogo': string;
    'secondaryLogo'?: string | null;
    'lightModeLogo'?: string | null;
    'favIconUrl'?: string | null;
    'fabricksLogo'?: string | null;
}
export interface Block {
    'id': string;
    'type': string;
    'isShown': boolean;
    'properties': string;
    'styling': BlockStyling;
}
export interface BlockStyling {
    'usesGlobalTheme': boolean;
    'theme'?: { [key: string]: string; } | null;
}
export interface ChangeDomainConfigurationRequest {
    'domain': string;
}
export interface CombinedHeaderStyling {
    'desktop': HeaderStyling;
    'mobile': HeaderStyling;
}
export interface ConfigurationDefinition {
    'styling': Styling;
    'assets': Assets;
    'header': Header;
    'footer': Footer;
    'pages': Array<Page>;
    'properties': Properties;
    'configurationDefaultHead': Head;
}
export interface CopyConfigurationRequest {
    'newConfigurationName': string;
    'newConfigurationPlatformId'?: string | null;
}
export interface CreateConfigurationRequest {
    'platformId': string;
    'name': string;
    'definition': ConfigurationDefinition;
}
export interface CreatePlatformRequest {
    'platformId'?: string | null;
    'name': string;
    'primaryDomain': string;
    'isAuctionsEnabled': boolean;
    'isFramingSupported': boolean;
    'isFabricksEnabled': boolean;
    'webhookSettings'?: PlatformWebhookSettingsRequest | null;
    'onlyAutomaticallyPublishFixtureEvents': boolean;
    'trackingSettings'?: PlatformTrackingSettingsRequest | null;
}
/**
 * http request object for creating a new lambda@edge redirect.
 */
export interface CreateRedirectRequest {
    'original': string;
    'redirect': string;
    'maxAge': number;
    'active'?: boolean | null;
}
export interface Currency {
    'name': string;
    'isoCurrencyCode': string;
    'symbol': string;
}
export interface DomainResponse {
    'name': string;
    'platformConfigurationResponse': PlatformConfigurationResponse;
    'platformId': string;
    'platform': PlatformResponse;
}
export interface Font {
    'url': string;
    'weight': string;
}
export interface Footer {
    'type'?: string | null;
    'properties': FooterProperties;
}
export interface FooterProperties {
    'supportEmail'?: string | null;
    'availableSocials': Array<Social>;
    'paymentOptions': Array<PaymentOption>;
    'isSubfooterShown': boolean;
    'logo': string;
    'menuLinks': Array<MenuLink>;
    'styling': BlockStyling;
    'newsletterOptions': NewsletterOptions;
}
export interface Head {
    'meta': HeadMeta;
}
export interface HeadMeta {
    'description': string;
}
export interface Header {
    'type'?: string | null;
    'properties': HeaderProperties;
}
export interface HeaderProperties {
    'logo': string;
    'productAuthenticationActive': boolean;
    'announcements': Array<Announcement>;
    'menuLinks': Array<MenuLink>;
    'styling': CombinedHeaderStyling;
}
export interface HeaderStyling {
    'fontWeight'?: string | null;
    'usesGlobalTheme': boolean;
    'theme'?: { [key: string]: string; } | null;
}
export interface Language {
    'isoLanguageCode': string;
}
export interface LimitedDomainResponse {
    'id': string;
    'name': string;
    'platformId': string;
    'configurationId': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
}
export interface MenuLink {
    'label'?: { [key: string]: string; } | null;
    'type': string;
    'path': string;
}
export interface NewsletterOptions {
    'enabled': boolean;
    'theme'?: { [key: string]: string; } | null;
}
export interface OriginResponse {
    'platformId': string;
    'platformName': string;
    'origin': string;
}
export interface OriginsResponse {
    'origins': Array<OriginResponse>;
}
export interface Page {
    'id': string;
    'type': string;
    'name': string;
    'route': PageRoute;
    'settings': Settings;
    'blocks': Array<Block>;
}
export interface PageRoute {
    'path': string;
    'name': string;
}
export interface PaginatedListOfAdminListPlatformResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminListPlatformResponse>;
}
export interface PaginatedListOfAdminPlatformConfigurationResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminPlatformConfigurationResponse>;
}
export interface PaymentOption {
    'name': string;
    'imageUri': string;
}
export interface PlatformArchiveRequest {
    'isArchived': boolean;
}
export interface PlatformConfigurationResponse {
    'name': string;
    'definition': ConfigurationDefinition;
}
export interface PlatformResponse {
    'id': string;
    'name': string;
    'isFramingSupported': boolean;
    'isAuctionsEnabled': boolean;
    'hasExternalIdp': boolean;
    'isArchived': boolean;
    'domains': Array<LimitedDomainResponse>;
    'primaryLimitedDomain': LimitedDomainResponse;
    'redirects': Array<RedirectResponse>;
    'allowedOrigins': Array<string>;
    'cookieBotKey'?: string | null;
}
export interface PlatformTrackingSettingsRequest {
    'isEnabled': boolean;
    'segmentWriteKey': string;
    'ga4MeasurementId': string;
}
export interface PlatformTrackingSettingsResponse {
    'isEnabled': boolean;
    'segmentWriteKey': string;
    'ga4MeasurementId': string;
}
export interface PlatformWebhookSettingsRequest {
    'urls'?: Array<string> | null;
    'headers'?: { [key: string]: string; } | null;
}
export interface PlatformWebhookSettingsResponse {
    'urls': Array<string>;
    'headers': { [key: string]: string; };
}
export interface Properties {
    'referencesMatchWornShirt': boolean;
    'isFrameTheGameOfficialPartner': boolean;
    'isCategorySearchEnabled': boolean;
    'usePlatformFabricksLogo': boolean;
    'defaultLanguage': Language;
    'availableLanguages': Array<Language>;
    'defaultCurrency': Currency;
    'availableCurrencies': Array<Currency>;
    'availableSupportChannels': Array<SupportChannel>;
    'featureFlags': { [key: string]: boolean; };
}
export interface PutDomainRequest {
    'currentDomainName'?: string | null;
    'newDomainName': string;
    'platformId': string;
    'isFabricksDomain': boolean;
}
/**
 * http request reponse object for redirects
 */
export interface RedirectResponse {
    'active': boolean;
    'original': string;
    'redirect': string;
    'maxAge': number;
}
export interface Settings {
    'menuEnabled': boolean;
    'footerEnabled': boolean;
}
export interface Social {
    'name'?: string | null;
    'imageUri'?: string | null;
    'qrCodeUri'?: string | null;
    'link'?: string | null;
}
export interface Styling {
    'iconPack'?: string | null;
    'background'?: string | null;
    'theme': { [key: string]: string; };
    'fonts': Array<Font>;
}
export interface SupportChannel {
    'id'?: string | null;
    'name': string;
    'title': string;
    'description'?: string | null;
    'imageUrl'?: string | null;
    'link'?: string | null;
    'qrCodeUrl'?: string | null;
    'type'?: string | null;
}
export interface TrackingSettingsResponse {
    'isEnabled': boolean;
    'segmentWriteKey': string;
    'ga4MeasurementId': string;
}
export interface UpdateConfigurationRequest {
    'name'?: string | null;
    'definition'?: ConfigurationDefinition | null;
}
export interface UpdatePlatformRequest {
    'name'?: string | null;
    'isAuctionsEnabled'?: boolean | null;
    'isFramingSupported'?: boolean | null;
    'isFabricksEnabled'?: boolean | null;
    'onlyAutomaticallyPublishFixtureEvents'?: boolean | null;
    'primaryDomain'?: string | null;
    'allowedOrigins'?: Array<string> | null;
    'partnerIds'?: Array<string> | null;
    'webhookSettings'?: PlatformWebhookSettingsRequest | null;
    'trackingSettings'?: PlatformTrackingSettingsRequest | null;
    'cookieBotKey'?: string | null;
}
export interface UpdateRedirectRequest {
    'original'?: string | null;
    'redirect'?: string | null;
    'maxAge'?: number | null;
    'active'?: boolean | null;
}

/**
 * AdminAllowedOriginsApi - axios parameter creator
 */
export const AdminAllowedOriginsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Disallows an origin from our platform
         * @param {string} platformId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformPlatformIdAllowedOriginsDelete: async (platformId: string, origin?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformPlatformIdAllowedOriginsDelete', 'platformId', platformId)
            const localVarPath = `/admin/platform/{platformId}/allowed-origins`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (origin !== undefined) {
                localVarQueryParameter['origin'] = origin;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allows an origin to send requests to the platform.
         * @param {string} platformId 
         * @param {AllowOriginRequest} allowOriginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformPlatformIdAllowedOriginsPost: async (platformId: string, allowOriginRequest: AllowOriginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformPlatformIdAllowedOriginsPost', 'platformId', platformId)
            // verify required parameter 'allowOriginRequest' is not null or undefined
            assertParamExists('adminPlatformPlatformIdAllowedOriginsPost', 'allowOriginRequest', allowOriginRequest)
            const localVarPath = `/admin/platform/{platformId}/allowed-origins`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(allowOriginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAllowedOriginsApi - functional programming interface
 */
export const AdminAllowedOriginsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAllowedOriginsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Disallows an origin from our platform
         * @param {string} platformId 
         * @param {string} [origin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformPlatformIdAllowedOriginsDelete(platformId: string, origin?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformPlatformIdAllowedOriginsDelete(platformId, origin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAllowedOriginsApi.adminPlatformPlatformIdAllowedOriginsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Allows an origin to send requests to the platform.
         * @param {string} platformId 
         * @param {AllowOriginRequest} allowOriginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformPlatformIdAllowedOriginsPost(platformId: string, allowOriginRequest: AllowOriginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OriginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformPlatformIdAllowedOriginsPost(platformId, allowOriginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAllowedOriginsApi.adminPlatformPlatformIdAllowedOriginsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAllowedOriginsApi - factory interface
 */
export const AdminAllowedOriginsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAllowedOriginsApiFp(configuration)
    return {
        /**
         * 
         * @summary Disallows an origin from our platform
         * @param {AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformPlatformIdAllowedOriginsDelete(requestParameters: AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPlatformPlatformIdAllowedOriginsDelete(requestParameters.platformId, requestParameters.origin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allows an origin to send requests to the platform.
         * @param {AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformPlatformIdAllowedOriginsPost(requestParameters: AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<OriginResponse> {
            return localVarFp.adminPlatformPlatformIdAllowedOriginsPost(requestParameters.platformId, requestParameters.allowOriginRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPlatformPlatformIdAllowedOriginsDelete operation in AdminAllowedOriginsApi.
 */
export interface AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsDeleteRequest {
    /**
     * 
     */
    readonly platformId: string

    /**
     * 
     */
    readonly origin?: string
}

/**
 * Request parameters for adminPlatformPlatformIdAllowedOriginsPost operation in AdminAllowedOriginsApi.
 */
export interface AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsPostRequest {
    /**
     * 
     */
    readonly platformId: string

    /**
     * 
     */
    readonly allowOriginRequest: AllowOriginRequest
}

/**
 * AdminAllowedOriginsApi - object-oriented interface
 */
export class AdminAllowedOriginsApi extends BaseAPI {
    /**
     * 
     * @summary Disallows an origin from our platform
     * @param {AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformPlatformIdAllowedOriginsDelete(requestParameters: AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminAllowedOriginsApiFp(this.configuration).adminPlatformPlatformIdAllowedOriginsDelete(requestParameters.platformId, requestParameters.origin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allows an origin to send requests to the platform.
     * @param {AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformPlatformIdAllowedOriginsPost(requestParameters: AdminAllowedOriginsApiAdminPlatformPlatformIdAllowedOriginsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminAllowedOriginsApiFp(this.configuration).adminPlatformPlatformIdAllowedOriginsPost(requestParameters.platformId, requestParameters.allowOriginRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminConfigurationsApi - axios parameter creator
 */
export const AdminConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary     Deletes the configuration You can\'t delete if the configuration is being used in any of the domains
         * @param {string} configurationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdDelete: async (configurationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminConfigurationsConfigurationIdDelete', 'configurationId', configurationId)
            const localVarPath = `/admin/configurations/{configurationId}`
                .replace('{configurationId}', encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets configuration by id
         * @param {string} configurationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdGet: async (configurationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminConfigurationsConfigurationIdGet', 'configurationId', configurationId)
            const localVarPath = `/admin/configurations/{configurationId}`
                .replace('{configurationId}', encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates Configuration
         * @param {string} configurationId 
         * @param {UpdateConfigurationRequest} updateConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdPatch: async (configurationId: string, updateConfigurationRequest: UpdateConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminConfigurationsConfigurationIdPatch', 'configurationId', configurationId)
            // verify required parameter 'updateConfigurationRequest' is not null or undefined
            assertParamExists('adminConfigurationsConfigurationIdPatch', 'updateConfigurationRequest', updateConfigurationRequest)
            const localVarPath = `/admin/configurations/{configurationId}`
                .replace('{configurationId}', encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get configuration
         * @param {string} [searchTerm] 
         * @param {string} [platformId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsGet: async (searchTerm?: string, platformId?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates configuration
         * @param {CreateConfigurationRequest} createConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsPost: async (createConfigurationRequest: CreateConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createConfigurationRequest' is not null or undefined
            assertParamExists('adminConfigurationsPost', 'createConfigurationRequest', createConfigurationRequest)
            const localVarPath = `/admin/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Copies a existing configuration and creates a new one
         * @param {string} sourceId configuration\&#39;s Id to copy
         * @param {CopyConfigurationRequest} copyConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsSourceIdCopyPost: async (sourceId: string, copyConfigurationRequest: CopyConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('adminConfigurationsSourceIdCopyPost', 'sourceId', sourceId)
            // verify required parameter 'copyConfigurationRequest' is not null or undefined
            assertParamExists('adminConfigurationsSourceIdCopyPost', 'copyConfigurationRequest', copyConfigurationRequest)
            const localVarPath = `/admin/configurations/{sourceId}/copy`
                .replace('{sourceId}', encodeURIComponent(String(sourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminConfigurationsApi - functional programming interface
 */
export const AdminConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary     Deletes the configuration You can\'t delete if the configuration is being used in any of the domains
         * @param {string} configurationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigurationsConfigurationIdDelete(configurationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigurationsConfigurationIdDelete(configurationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminConfigurationsApi.adminConfigurationsConfigurationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets configuration by id
         * @param {string} configurationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigurationsConfigurationIdGet(configurationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPlatformConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigurationsConfigurationIdGet(configurationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminConfigurationsApi.adminConfigurationsConfigurationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates Configuration
         * @param {string} configurationId 
         * @param {UpdateConfigurationRequest} updateConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigurationsConfigurationIdPatch(configurationId: string, updateConfigurationRequest: UpdateConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPlatformConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigurationsConfigurationIdPatch(configurationId, updateConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminConfigurationsApi.adminConfigurationsConfigurationIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get configuration
         * @param {string} [searchTerm] 
         * @param {string} [platformId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigurationsGet(searchTerm?: string, platformId?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminPlatformConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigurationsGet(searchTerm, platformId, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminConfigurationsApi.adminConfigurationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates configuration
         * @param {CreateConfigurationRequest} createConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigurationsPost(createConfigurationRequest: CreateConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPlatformConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigurationsPost(createConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminConfigurationsApi.adminConfigurationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Copies a existing configuration and creates a new one
         * @param {string} sourceId configuration\&#39;s Id to copy
         * @param {CopyConfigurationRequest} copyConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigurationsSourceIdCopyPost(sourceId: string, copyConfigurationRequest: CopyConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPlatformConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigurationsSourceIdCopyPost(sourceId, copyConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminConfigurationsApi.adminConfigurationsSourceIdCopyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminConfigurationsApi - factory interface
 */
export const AdminConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminConfigurationsApiFp(configuration)
    return {
        /**
         * 
         * @summary     Deletes the configuration You can\'t delete if the configuration is being used in any of the domains
         * @param {AdminConfigurationsApiAdminConfigurationsConfigurationIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdDelete(requestParameters: AdminConfigurationsApiAdminConfigurationsConfigurationIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminConfigurationsConfigurationIdDelete(requestParameters.configurationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets configuration by id
         * @param {AdminConfigurationsApiAdminConfigurationsConfigurationIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdGet(requestParameters: AdminConfigurationsApiAdminConfigurationsConfigurationIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPlatformConfigurationResponse> {
            return localVarFp.adminConfigurationsConfigurationIdGet(requestParameters.configurationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates Configuration
         * @param {AdminConfigurationsApiAdminConfigurationsConfigurationIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsConfigurationIdPatch(requestParameters: AdminConfigurationsApiAdminConfigurationsConfigurationIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPlatformConfigurationResponse> {
            return localVarFp.adminConfigurationsConfigurationIdPatch(requestParameters.configurationId, requestParameters.updateConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get configuration
         * @param {AdminConfigurationsApiAdminConfigurationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsGet(requestParameters: AdminConfigurationsApiAdminConfigurationsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminPlatformConfigurationResponse> {
            return localVarFp.adminConfigurationsGet(requestParameters.searchTerm, requestParameters.platformId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates configuration
         * @param {AdminConfigurationsApiAdminConfigurationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsPost(requestParameters: AdminConfigurationsApiAdminConfigurationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPlatformConfigurationResponse> {
            return localVarFp.adminConfigurationsPost(requestParameters.createConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Copies a existing configuration and creates a new one
         * @param {AdminConfigurationsApiAdminConfigurationsSourceIdCopyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigurationsSourceIdCopyPost(requestParameters: AdminConfigurationsApiAdminConfigurationsSourceIdCopyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPlatformConfigurationResponse> {
            return localVarFp.adminConfigurationsSourceIdCopyPost(requestParameters.sourceId, requestParameters.copyConfigurationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminConfigurationsConfigurationIdDelete operation in AdminConfigurationsApi.
 */
export interface AdminConfigurationsApiAdminConfigurationsConfigurationIdDeleteRequest {
    /**
     * 
     */
    readonly configurationId: string
}

/**
 * Request parameters for adminConfigurationsConfigurationIdGet operation in AdminConfigurationsApi.
 */
export interface AdminConfigurationsApiAdminConfigurationsConfigurationIdGetRequest {
    /**
     * 
     */
    readonly configurationId: string
}

/**
 * Request parameters for adminConfigurationsConfigurationIdPatch operation in AdminConfigurationsApi.
 */
export interface AdminConfigurationsApiAdminConfigurationsConfigurationIdPatchRequest {
    /**
     * 
     */
    readonly configurationId: string

    /**
     * 
     */
    readonly updateConfigurationRequest: UpdateConfigurationRequest
}

/**
 * Request parameters for adminConfigurationsGet operation in AdminConfigurationsApi.
 */
export interface AdminConfigurationsApiAdminConfigurationsGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly platformId?: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminConfigurationsPost operation in AdminConfigurationsApi.
 */
export interface AdminConfigurationsApiAdminConfigurationsPostRequest {
    /**
     * 
     */
    readonly createConfigurationRequest: CreateConfigurationRequest
}

/**
 * Request parameters for adminConfigurationsSourceIdCopyPost operation in AdminConfigurationsApi.
 */
export interface AdminConfigurationsApiAdminConfigurationsSourceIdCopyPostRequest {
    /**
     * configuration\&#39;s Id to copy
     */
    readonly sourceId: string

    /**
     * 
     */
    readonly copyConfigurationRequest: CopyConfigurationRequest
}

/**
 * AdminConfigurationsApi - object-oriented interface
 */
export class AdminConfigurationsApi extends BaseAPI {
    /**
     * 
     * @summary     Deletes the configuration You can\'t delete if the configuration is being used in any of the domains
     * @param {AdminConfigurationsApiAdminConfigurationsConfigurationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminConfigurationsConfigurationIdDelete(requestParameters: AdminConfigurationsApiAdminConfigurationsConfigurationIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminConfigurationsApiFp(this.configuration).adminConfigurationsConfigurationIdDelete(requestParameters.configurationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets configuration by id
     * @param {AdminConfigurationsApiAdminConfigurationsConfigurationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminConfigurationsConfigurationIdGet(requestParameters: AdminConfigurationsApiAdminConfigurationsConfigurationIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminConfigurationsApiFp(this.configuration).adminConfigurationsConfigurationIdGet(requestParameters.configurationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates Configuration
     * @param {AdminConfigurationsApiAdminConfigurationsConfigurationIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminConfigurationsConfigurationIdPatch(requestParameters: AdminConfigurationsApiAdminConfigurationsConfigurationIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminConfigurationsApiFp(this.configuration).adminConfigurationsConfigurationIdPatch(requestParameters.configurationId, requestParameters.updateConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get configuration
     * @param {AdminConfigurationsApiAdminConfigurationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminConfigurationsGet(requestParameters: AdminConfigurationsApiAdminConfigurationsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminConfigurationsApiFp(this.configuration).adminConfigurationsGet(requestParameters.searchTerm, requestParameters.platformId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates configuration
     * @param {AdminConfigurationsApiAdminConfigurationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminConfigurationsPost(requestParameters: AdminConfigurationsApiAdminConfigurationsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminConfigurationsApiFp(this.configuration).adminConfigurationsPost(requestParameters.createConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Copies a existing configuration and creates a new one
     * @param {AdminConfigurationsApiAdminConfigurationsSourceIdCopyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminConfigurationsSourceIdCopyPost(requestParameters: AdminConfigurationsApiAdminConfigurationsSourceIdCopyPostRequest, options?: RawAxiosRequestConfig) {
        return AdminConfigurationsApiFp(this.configuration).adminConfigurationsSourceIdCopyPost(requestParameters.sourceId, requestParameters.copyConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDomainsApi - axios parameter creator
 */
export const AdminDomainsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Changes the domains configuration to the given configuration
         * @param {string} configurationId 
         * @param {ChangeDomainConfigurationRequest} changeDomainConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsConfigurationConfigurationIdPatch: async (configurationId: string, changeDomainConfigurationRequest: ChangeDomainConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('adminDomainsConfigurationConfigurationIdPatch', 'configurationId', configurationId)
            // verify required parameter 'changeDomainConfigurationRequest' is not null or undefined
            assertParamExists('adminDomainsConfigurationConfigurationIdPatch', 'changeDomainConfigurationRequest', changeDomainConfigurationRequest)
            const localVarPath = `/admin/domains/configuration/{configurationId}`
                .replace('{configurationId}', encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeDomainConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a domain lookup
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsDelete: async (domain?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a domain lookup
         * @param {string} [platformId] the id of the platform that this domain should refer to.
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsPost: async (platformId?: string, domain?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary mark a domain as the primary domain for its platform.
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsPrimaryPatch: async (domain?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/domains/primary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] create or update a domain
         * @param {PutDomainRequest} putDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsPut: async (putDomainRequest: PutDomainRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'putDomainRequest' is not null or undefined
            assertParamExists('adminDomainsPut', 'putDomainRequest', putDomainRequest)
            const localVarPath = `/admin/domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putDomainRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDomainsApi - functional programming interface
 */
export const AdminDomainsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDomainsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Changes the domains configuration to the given configuration
         * @param {string} configurationId 
         * @param {ChangeDomainConfigurationRequest} changeDomainConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDomainsConfigurationConfigurationIdPatch(configurationId: string, changeDomainConfigurationRequest: ChangeDomainConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDomainsConfigurationConfigurationIdPatch(configurationId, changeDomainConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDomainsApi.adminDomainsConfigurationConfigurationIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a domain lookup
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDomainsDelete(domain?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDomainsDelete(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDomainsApi.adminDomainsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a domain lookup
         * @param {string} [platformId] the id of the platform that this domain should refer to.
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDomainsPost(platformId?: string, domain?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDomainsPost(platformId, domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDomainsApi.adminDomainsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary mark a domain as the primary domain for its platform.
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDomainsPrimaryPatch(domain?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDomainsPrimaryPatch(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDomainsApi.adminDomainsPrimaryPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] create or update a domain
         * @param {PutDomainRequest} putDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDomainsPut(putDomainRequest: PutDomainRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDomainsPut(putDomainRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDomainsApi.adminDomainsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDomainsApi - factory interface
 */
export const AdminDomainsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDomainsApiFp(configuration)
    return {
        /**
         * 
         * @summary Changes the domains configuration to the given configuration
         * @param {AdminDomainsApiAdminDomainsConfigurationConfigurationIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsConfigurationConfigurationIdPatch(requestParameters: AdminDomainsApiAdminDomainsConfigurationConfigurationIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDomainResponse> {
            return localVarFp.adminDomainsConfigurationConfigurationIdPatch(requestParameters.configurationId, requestParameters.changeDomainConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a domain lookup
         * @param {AdminDomainsApiAdminDomainsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsDelete(requestParameters: AdminDomainsApiAdminDomainsDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDomainsDelete(requestParameters.domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a domain lookup
         * @param {AdminDomainsApiAdminDomainsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsPost(requestParameters: AdminDomainsApiAdminDomainsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminDomainResponse> {
            return localVarFp.adminDomainsPost(requestParameters.platformId, requestParameters.domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary mark a domain as the primary domain for its platform.
         * @param {AdminDomainsApiAdminDomainsPrimaryPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsPrimaryPatch(requestParameters: AdminDomainsApiAdminDomainsPrimaryPatchRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminDomainResponse> {
            return localVarFp.adminDomainsPrimaryPatch(requestParameters.domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] create or update a domain
         * @param {AdminDomainsApiAdminDomainsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDomainsPut(requestParameters: AdminDomainsApiAdminDomainsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDomainResponse> {
            return localVarFp.adminDomainsPut(requestParameters.putDomainRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminDomainsConfigurationConfigurationIdPatch operation in AdminDomainsApi.
 */
export interface AdminDomainsApiAdminDomainsConfigurationConfigurationIdPatchRequest {
    /**
     * 
     */
    readonly configurationId: string

    /**
     * 
     */
    readonly changeDomainConfigurationRequest: ChangeDomainConfigurationRequest
}

/**
 * Request parameters for adminDomainsDelete operation in AdminDomainsApi.
 */
export interface AdminDomainsApiAdminDomainsDeleteRequest {
    /**
     * 
     */
    readonly domain?: string
}

/**
 * Request parameters for adminDomainsPost operation in AdminDomainsApi.
 */
export interface AdminDomainsApiAdminDomainsPostRequest {
    /**
     * the id of the platform that this domain should refer to.
     */
    readonly platformId?: string

    /**
     * 
     */
    readonly domain?: string
}

/**
 * Request parameters for adminDomainsPrimaryPatch operation in AdminDomainsApi.
 */
export interface AdminDomainsApiAdminDomainsPrimaryPatchRequest {
    /**
     * 
     */
    readonly domain?: string
}

/**
 * Request parameters for adminDomainsPut operation in AdminDomainsApi.
 */
export interface AdminDomainsApiAdminDomainsPutRequest {
    readonly putDomainRequest: PutDomainRequest
}

/**
 * AdminDomainsApi - object-oriented interface
 */
export class AdminDomainsApi extends BaseAPI {
    /**
     * 
     * @summary Changes the domains configuration to the given configuration
     * @param {AdminDomainsApiAdminDomainsConfigurationConfigurationIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDomainsConfigurationConfigurationIdPatch(requestParameters: AdminDomainsApiAdminDomainsConfigurationConfigurationIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminDomainsApiFp(this.configuration).adminDomainsConfigurationConfigurationIdPatch(requestParameters.configurationId, requestParameters.changeDomainConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a domain lookup
     * @param {AdminDomainsApiAdminDomainsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDomainsDelete(requestParameters: AdminDomainsApiAdminDomainsDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminDomainsApiFp(this.configuration).adminDomainsDelete(requestParameters.domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a domain lookup
     * @param {AdminDomainsApiAdminDomainsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDomainsPost(requestParameters: AdminDomainsApiAdminDomainsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminDomainsApiFp(this.configuration).adminDomainsPost(requestParameters.platformId, requestParameters.domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary mark a domain as the primary domain for its platform.
     * @param {AdminDomainsApiAdminDomainsPrimaryPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDomainsPrimaryPatch(requestParameters: AdminDomainsApiAdminDomainsPrimaryPatchRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminDomainsApiFp(this.configuration).adminDomainsPrimaryPatch(requestParameters.domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] create or update a domain
     * @param {AdminDomainsApiAdminDomainsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDomainsPut(requestParameters: AdminDomainsApiAdminDomainsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminDomainsApiFp(this.configuration).adminDomainsPut(requestParameters.putDomainRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFontsApi - axios parameter creator
 */
export const AdminFontsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} platformId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdFontsPost: async (platformId: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdFontsPost', 'platformId', platformId)
            const localVarPath = `/admin/platforms/{platformId}/fonts`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (file !== undefined) { 
                localVarFormParams.set('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFontsApi - functional programming interface
 */
export const AdminFontsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFontsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} platformId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdFontsPost(platformId: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdFontsPost(platformId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFontsApi.adminPlatformsPlatformIdFontsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFontsApi - factory interface
 */
export const AdminFontsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFontsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminFontsApiAdminPlatformsPlatformIdFontsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdFontsPost(requestParameters: AdminFontsApiAdminPlatformsPlatformIdFontsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminPlatformsPlatformIdFontsPost(requestParameters.platformId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPlatformsPlatformIdFontsPost operation in AdminFontsApi.
 */
export interface AdminFontsApiAdminPlatformsPlatformIdFontsPostRequest {
    readonly platformId: string

    readonly file?: File
}

/**
 * AdminFontsApi - object-oriented interface
 */
export class AdminFontsApi extends BaseAPI {
    /**
     * 
     * @param {AdminFontsApiAdminPlatformsPlatformIdFontsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdFontsPost(requestParameters: AdminFontsApiAdminPlatformsPlatformIdFontsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminFontsApiFp(this.configuration).adminPlatformsPlatformIdFontsPost(requestParameters.platformId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPlatformsApi - axios parameter creator
 */
export const AdminPlatformsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all platform configurations
         * @param {string} [platformIds] 
         * @param {string} [partnerIds] 
         * @param {string} [searchTerm] to search on name, or match with Id
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsGet: async (platformIds?: string, partnerIds?: string, searchTerm?: string, isArchived?: boolean, offset?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/platforms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platformIds !== undefined) {
                localVarQueryParameter['platformIds'] = platformIds;
            }

            if (partnerIds !== undefined) {
                localVarQueryParameter['partnerIds'] = partnerIds;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} platformId 
         * @param {PlatformArchiveRequest} platformArchiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdArchivePatch: async (platformId: string, platformArchiveRequest: PlatformArchiveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdArchivePatch', 'platformId', platformId)
            // verify required parameter 'platformArchiveRequest' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdArchivePatch', 'platformArchiveRequest', platformArchiveRequest)
            const localVarPath = `/admin/platforms/{platformId}/archive`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(platformArchiveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete platform configuration by id
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdDelete: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdDelete', 'platformId', platformId)
            const localVarPath = `/admin/platforms/{platformId}`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get platform configuration by id
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdGet: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdGet', 'platformId', platformId)
            const localVarPath = `/admin/platforms/{platformId}`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a platform
         * @param {string} platformId 
         * @param {UpdatePlatformRequest} updatePlatformRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdPatch: async (platformId: string, updatePlatformRequest: UpdatePlatformRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdPatch', 'platformId', platformId)
            // verify required parameter 'updatePlatformRequest' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdPatch', 'updatePlatformRequest', updatePlatformRequest)
            const localVarPath = `/admin/platforms/{platformId}`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlatformRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new platform configuration
         * @param {CreatePlatformRequest} createPlatformRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPost: async (createPlatformRequest: CreatePlatformRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPlatformRequest' is not null or undefined
            assertParamExists('adminPlatformsPost', 'createPlatformRequest', createPlatformRequest)
            const localVarPath = `/admin/platforms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlatformRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPlatformsApi - functional programming interface
 */
export const AdminPlatformsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPlatformsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all platform configurations
         * @param {string} [platformIds] 
         * @param {string} [partnerIds] 
         * @param {string} [searchTerm] to search on name, or match with Id
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsGet(platformIds?: string, partnerIds?: string, searchTerm?: string, isArchived?: boolean, offset?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminListPlatformResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsGet(platformIds, partnerIds, searchTerm, isArchived, offset, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPlatformsApi.adminPlatformsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} platformId 
         * @param {PlatformArchiveRequest} platformArchiveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdArchivePatch(platformId: string, platformArchiveRequest: PlatformArchiveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdArchivePatch(platformId, platformArchiveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPlatformsApi.adminPlatformsPlatformIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete platform configuration by id
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdDelete(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdDelete(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPlatformsApi.adminPlatformsPlatformIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get platform configuration by id
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdGet(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPlatformResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdGet(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPlatformsApi.adminPlatformsPlatformIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a platform
         * @param {string} platformId 
         * @param {UpdatePlatformRequest} updatePlatformRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdPatch(platformId: string, updatePlatformRequest: UpdatePlatformRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPlatformResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdPatch(platformId, updatePlatformRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPlatformsApi.adminPlatformsPlatformIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new platform configuration
         * @param {CreatePlatformRequest} createPlatformRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPost(createPlatformRequest: CreatePlatformRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPlatformResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPost(createPlatformRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPlatformsApi.adminPlatformsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPlatformsApi - factory interface
 */
export const AdminPlatformsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPlatformsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all platform configurations
         * @param {AdminPlatformsApiAdminPlatformsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsGet(requestParameters: AdminPlatformsApiAdminPlatformsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminListPlatformResponse> {
            return localVarFp.adminPlatformsGet(requestParameters.platformIds, requestParameters.partnerIds, requestParameters.searchTerm, requestParameters.isArchived, requestParameters.offset, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminPlatformsApiAdminPlatformsPlatformIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdArchivePatch(requestParameters: AdminPlatformsApiAdminPlatformsPlatformIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPlatformsPlatformIdArchivePatch(requestParameters.platformId, requestParameters.platformArchiveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete platform configuration by id
         * @param {AdminPlatformsApiAdminPlatformsPlatformIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdDelete(requestParameters: AdminPlatformsApiAdminPlatformsPlatformIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPlatformsPlatformIdDelete(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get platform configuration by id
         * @param {AdminPlatformsApiAdminPlatformsPlatformIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdGet(requestParameters: AdminPlatformsApiAdminPlatformsPlatformIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPlatformResponse> {
            return localVarFp.adminPlatformsPlatformIdGet(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a platform
         * @param {AdminPlatformsApiAdminPlatformsPlatformIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdPatch(requestParameters: AdminPlatformsApiAdminPlatformsPlatformIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPlatformResponse> {
            return localVarFp.adminPlatformsPlatformIdPatch(requestParameters.platformId, requestParameters.updatePlatformRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new platform configuration
         * @param {AdminPlatformsApiAdminPlatformsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPost(requestParameters: AdminPlatformsApiAdminPlatformsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPlatformResponse> {
            return localVarFp.adminPlatformsPost(requestParameters.createPlatformRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPlatformsGet operation in AdminPlatformsApi.
 */
export interface AdminPlatformsApiAdminPlatformsGetRequest {
    /**
     * 
     */
    readonly platformIds?: string

    /**
     * 
     */
    readonly partnerIds?: string

    /**
     * to search on name, or match with Id
     */
    readonly searchTerm?: string

    readonly isArchived?: boolean

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly size?: number
}

/**
 * Request parameters for adminPlatformsPlatformIdArchivePatch operation in AdminPlatformsApi.
 */
export interface AdminPlatformsApiAdminPlatformsPlatformIdArchivePatchRequest {
    readonly platformId: string

    readonly platformArchiveRequest: PlatformArchiveRequest
}

/**
 * Request parameters for adminPlatformsPlatformIdDelete operation in AdminPlatformsApi.
 */
export interface AdminPlatformsApiAdminPlatformsPlatformIdDeleteRequest {
    /**
     * 
     */
    readonly platformId: string
}

/**
 * Request parameters for adminPlatformsPlatformIdGet operation in AdminPlatformsApi.
 */
export interface AdminPlatformsApiAdminPlatformsPlatformIdGetRequest {
    /**
     * 
     */
    readonly platformId: string
}

/**
 * Request parameters for adminPlatformsPlatformIdPatch operation in AdminPlatformsApi.
 */
export interface AdminPlatformsApiAdminPlatformsPlatformIdPatchRequest {
    /**
     * 
     */
    readonly platformId: string

    /**
     * 
     */
    readonly updatePlatformRequest: UpdatePlatformRequest
}

/**
 * Request parameters for adminPlatformsPost operation in AdminPlatformsApi.
 */
export interface AdminPlatformsApiAdminPlatformsPostRequest {
    /**
     * 
     */
    readonly createPlatformRequest: CreatePlatformRequest
}

/**
 * AdminPlatformsApi - object-oriented interface
 */
export class AdminPlatformsApi extends BaseAPI {
    /**
     * 
     * @summary Get all platform configurations
     * @param {AdminPlatformsApiAdminPlatformsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsGet(requestParameters: AdminPlatformsApiAdminPlatformsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminPlatformsApiFp(this.configuration).adminPlatformsGet(requestParameters.platformIds, requestParameters.partnerIds, requestParameters.searchTerm, requestParameters.isArchived, requestParameters.offset, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminPlatformsApiAdminPlatformsPlatformIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdArchivePatch(requestParameters: AdminPlatformsApiAdminPlatformsPlatformIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminPlatformsApiFp(this.configuration).adminPlatformsPlatformIdArchivePatch(requestParameters.platformId, requestParameters.platformArchiveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete platform configuration by id
     * @param {AdminPlatformsApiAdminPlatformsPlatformIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdDelete(requestParameters: AdminPlatformsApiAdminPlatformsPlatformIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminPlatformsApiFp(this.configuration).adminPlatformsPlatformIdDelete(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get platform configuration by id
     * @param {AdminPlatformsApiAdminPlatformsPlatformIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdGet(requestParameters: AdminPlatformsApiAdminPlatformsPlatformIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminPlatformsApiFp(this.configuration).adminPlatformsPlatformIdGet(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a platform
     * @param {AdminPlatformsApiAdminPlatformsPlatformIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdPatch(requestParameters: AdminPlatformsApiAdminPlatformsPlatformIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminPlatformsApiFp(this.configuration).adminPlatformsPlatformIdPatch(requestParameters.platformId, requestParameters.updatePlatformRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new platform configuration
     * @param {AdminPlatformsApiAdminPlatformsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPost(requestParameters: AdminPlatformsApiAdminPlatformsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminPlatformsApiFp(this.configuration).adminPlatformsPost(requestParameters.createPlatformRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminRedirectsApi - axios parameter creator
 */
export const AdminRedirectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get redirects by platform. (admin)
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdRedirectsGet: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdRedirectsGet', 'platformId', platformId)
            const localVarPath = `/admin/platforms/{platformId}/redirects`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new redirect entry.
         * @param {string} platformId 
         * @param {CreateRedirectRequest} createRedirectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdRedirectsPost: async (platformId: string, createRedirectRequest: CreateRedirectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdRedirectsPost', 'platformId', platformId)
            // verify required parameter 'createRedirectRequest' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdRedirectsPost', 'createRedirectRequest', createRedirectRequest)
            const localVarPath = `/admin/platforms/{platformId}/redirects`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRedirectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a redirect.
         * @param {string} platformId 
         * @param {string} redirectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdRedirectsRedirectIdDelete: async (platformId: string, redirectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdRedirectsRedirectIdDelete', 'platformId', platformId)
            // verify required parameter 'redirectId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdRedirectsRedirectIdDelete', 'redirectId', redirectId)
            const localVarPath = `/admin/platforms/{platformId}/redirects/{redirectId}`
                .replace('{platformId}', encodeURIComponent(String(platformId)))
                .replace('{redirectId}', encodeURIComponent(String(redirectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary patch redirect entry.
         * @param {string} platformId 
         * @param {string} redirectId 
         * @param {UpdateRedirectRequest} updateRedirectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdRedirectsRedirectIdPatch: async (platformId: string, redirectId: string, updateRedirectRequest: UpdateRedirectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdRedirectsRedirectIdPatch', 'platformId', platformId)
            // verify required parameter 'redirectId' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdRedirectsRedirectIdPatch', 'redirectId', redirectId)
            // verify required parameter 'updateRedirectRequest' is not null or undefined
            assertParamExists('adminPlatformsPlatformIdRedirectsRedirectIdPatch', 'updateRedirectRequest', updateRedirectRequest)
            const localVarPath = `/admin/platforms/{platformId}/redirects/{redirectId}`
                .replace('{platformId}', encodeURIComponent(String(platformId)))
                .replace('{redirectId}', encodeURIComponent(String(redirectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRedirectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminRedirectsApi - functional programming interface
 */
export const AdminRedirectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminRedirectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get redirects by platform. (admin)
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdRedirectsGet(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminRedirectResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdRedirectsGet(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRedirectsApi.adminPlatformsPlatformIdRedirectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a new redirect entry.
         * @param {string} platformId 
         * @param {CreateRedirectRequest} createRedirectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdRedirectsPost(platformId: string, createRedirectRequest: CreateRedirectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRedirectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdRedirectsPost(platformId, createRedirectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRedirectsApi.adminPlatformsPlatformIdRedirectsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a redirect.
         * @param {string} platformId 
         * @param {string} redirectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdRedirectsRedirectIdDelete(platformId: string, redirectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdRedirectsRedirectIdDelete(platformId, redirectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRedirectsApi.adminPlatformsPlatformIdRedirectsRedirectIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary patch redirect entry.
         * @param {string} platformId 
         * @param {string} redirectId 
         * @param {UpdateRedirectRequest} updateRedirectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPlatformsPlatformIdRedirectsRedirectIdPatch(platformId: string, redirectId: string, updateRedirectRequest: UpdateRedirectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRedirectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPlatformsPlatformIdRedirectsRedirectIdPatch(platformId, redirectId, updateRedirectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRedirectsApi.adminPlatformsPlatformIdRedirectsRedirectIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminRedirectsApi - factory interface
 */
export const AdminRedirectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminRedirectsApiFp(configuration)
    return {
        /**
         * 
         * @summary get redirects by platform. (admin)
         * @param {AdminRedirectsApiAdminPlatformsPlatformIdRedirectsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdRedirectsGet(requestParameters: AdminRedirectsApiAdminPlatformsPlatformIdRedirectsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminRedirectResponse>> {
            return localVarFp.adminPlatformsPlatformIdRedirectsGet(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new redirect entry.
         * @param {AdminRedirectsApiAdminPlatformsPlatformIdRedirectsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdRedirectsPost(requestParameters: AdminRedirectsApiAdminPlatformsPlatformIdRedirectsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRedirectResponse> {
            return localVarFp.adminPlatformsPlatformIdRedirectsPost(requestParameters.platformId, requestParameters.createRedirectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a redirect.
         * @param {AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdRedirectsRedirectIdDelete(requestParameters: AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPlatformsPlatformIdRedirectsRedirectIdDelete(requestParameters.platformId, requestParameters.redirectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary patch redirect entry.
         * @param {AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPlatformsPlatformIdRedirectsRedirectIdPatch(requestParameters: AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRedirectResponse> {
            return localVarFp.adminPlatformsPlatformIdRedirectsRedirectIdPatch(requestParameters.platformId, requestParameters.redirectId, requestParameters.updateRedirectRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPlatformsPlatformIdRedirectsGet operation in AdminRedirectsApi.
 */
export interface AdminRedirectsApiAdminPlatformsPlatformIdRedirectsGetRequest {
    /**
     * 
     */
    readonly platformId: string
}

/**
 * Request parameters for adminPlatformsPlatformIdRedirectsPost operation in AdminRedirectsApi.
 */
export interface AdminRedirectsApiAdminPlatformsPlatformIdRedirectsPostRequest {
    /**
     * 
     */
    readonly platformId: string

    /**
     * 
     */
    readonly createRedirectRequest: CreateRedirectRequest
}

/**
 * Request parameters for adminPlatformsPlatformIdRedirectsRedirectIdDelete operation in AdminRedirectsApi.
 */
export interface AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdDeleteRequest {
    /**
     * 
     */
    readonly platformId: string

    /**
     * 
     */
    readonly redirectId: string
}

/**
 * Request parameters for adminPlatformsPlatformIdRedirectsRedirectIdPatch operation in AdminRedirectsApi.
 */
export interface AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdPatchRequest {
    /**
     * 
     */
    readonly platformId: string

    /**
     * 
     */
    readonly redirectId: string

    /**
     * 
     */
    readonly updateRedirectRequest: UpdateRedirectRequest
}

/**
 * AdminRedirectsApi - object-oriented interface
 */
export class AdminRedirectsApi extends BaseAPI {
    /**
     * 
     * @summary get redirects by platform. (admin)
     * @param {AdminRedirectsApiAdminPlatformsPlatformIdRedirectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdRedirectsGet(requestParameters: AdminRedirectsApiAdminPlatformsPlatformIdRedirectsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminRedirectsApiFp(this.configuration).adminPlatformsPlatformIdRedirectsGet(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new redirect entry.
     * @param {AdminRedirectsApiAdminPlatformsPlatformIdRedirectsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdRedirectsPost(requestParameters: AdminRedirectsApiAdminPlatformsPlatformIdRedirectsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminRedirectsApiFp(this.configuration).adminPlatformsPlatformIdRedirectsPost(requestParameters.platformId, requestParameters.createRedirectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a redirect.
     * @param {AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdRedirectsRedirectIdDelete(requestParameters: AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminRedirectsApiFp(this.configuration).adminPlatformsPlatformIdRedirectsRedirectIdDelete(requestParameters.platformId, requestParameters.redirectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary patch redirect entry.
     * @param {AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPlatformsPlatformIdRedirectsRedirectIdPatch(requestParameters: AdminRedirectsApiAdminPlatformsPlatformIdRedirectsRedirectIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminRedirectsApiFp(this.configuration).adminPlatformsPlatformIdRedirectsRedirectIdPatch(requestParameters.platformId, requestParameters.redirectId, requestParameters.updateRedirectRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AllowedOriginsApi - axios parameter creator
 */
export const AllowedOriginsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests.
         * @param {string} [searchTerm] 
         * @param {string} [platformId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowedOriginsAllGet: async (searchTerm?: string, platformId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/allowed-origins/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests to the platform.
         * @param {string} [platformId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowedOriginsGet: async (platformId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/allowed-origins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests.
         * @param {string} [searchTerm] 
         * @param {string} [platformId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAllowedOriginsAllGet: async (searchTerm?: string, platformId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/allowed-origins/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests to the platform.
         * @param {string} [platformId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAllowedOriginsGet: async (platformId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/allowed-origins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllowedOriginsApi - functional programming interface
 */
export const AllowedOriginsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllowedOriginsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests.
         * @param {string} [searchTerm] 
         * @param {string} [platformId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowedOriginsAllGet(searchTerm?: string, platformId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OriginsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowedOriginsAllGet(searchTerm, platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllowedOriginsApi.allowedOriginsAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests to the platform.
         * @param {string} [platformId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowedOriginsGet(platformId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OriginsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowedOriginsGet(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllowedOriginsApi.allowedOriginsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests.
         * @param {string} [searchTerm] 
         * @param {string} [platformId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAllowedOriginsAllGet(searchTerm?: string, platformId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OriginsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAllowedOriginsAllGet(searchTerm, platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllowedOriginsApi.internalAllowedOriginsAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests to the platform.
         * @param {string} [platformId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalAllowedOriginsGet(platformId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OriginsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalAllowedOriginsGet(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AllowedOriginsApi.internalAllowedOriginsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AllowedOriginsApi - factory interface
 */
export const AllowedOriginsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllowedOriginsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests.
         * @param {AllowedOriginsApiAllowedOriginsAllGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowedOriginsAllGet(requestParameters: AllowedOriginsApiAllowedOriginsAllGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OriginsResponse> {
            return localVarFp.allowedOriginsAllGet(requestParameters.searchTerm, requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests to the platform.
         * @param {AllowedOriginsApiAllowedOriginsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowedOriginsGet(requestParameters: AllowedOriginsApiAllowedOriginsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OriginsResponse> {
            return localVarFp.allowedOriginsGet(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests.
         * @param {AllowedOriginsApiInternalAllowedOriginsAllGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAllowedOriginsAllGet(requestParameters: AllowedOriginsApiInternalAllowedOriginsAllGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OriginsResponse> {
            return localVarFp.internalAllowedOriginsAllGet(requestParameters.searchTerm, requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all the origins that have been allowed to send requests to the platform.
         * @param {AllowedOriginsApiInternalAllowedOriginsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalAllowedOriginsGet(requestParameters: AllowedOriginsApiInternalAllowedOriginsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OriginsResponse> {
            return localVarFp.internalAllowedOriginsGet(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for allowedOriginsAllGet operation in AllowedOriginsApi.
 */
export interface AllowedOriginsApiAllowedOriginsAllGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly platformId?: string
}

/**
 * Request parameters for allowedOriginsGet operation in AllowedOriginsApi.
 */
export interface AllowedOriginsApiAllowedOriginsGetRequest {
    /**
     * 
     */
    readonly platformId?: string
}

/**
 * Request parameters for internalAllowedOriginsAllGet operation in AllowedOriginsApi.
 */
export interface AllowedOriginsApiInternalAllowedOriginsAllGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly platformId?: string
}

/**
 * Request parameters for internalAllowedOriginsGet operation in AllowedOriginsApi.
 */
export interface AllowedOriginsApiInternalAllowedOriginsGetRequest {
    /**
     * 
     */
    readonly platformId?: string
}

/**
 * AllowedOriginsApi - object-oriented interface
 */
export class AllowedOriginsApi extends BaseAPI {
    /**
     * 
     * @summary Returns all the origins that have been allowed to send requests.
     * @param {AllowedOriginsApiAllowedOriginsAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allowedOriginsAllGet(requestParameters: AllowedOriginsApiAllowedOriginsAllGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AllowedOriginsApiFp(this.configuration).allowedOriginsAllGet(requestParameters.searchTerm, requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all the origins that have been allowed to send requests to the platform.
     * @param {AllowedOriginsApiAllowedOriginsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public allowedOriginsGet(requestParameters: AllowedOriginsApiAllowedOriginsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AllowedOriginsApiFp(this.configuration).allowedOriginsGet(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all the origins that have been allowed to send requests.
     * @param {AllowedOriginsApiInternalAllowedOriginsAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalAllowedOriginsAllGet(requestParameters: AllowedOriginsApiInternalAllowedOriginsAllGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AllowedOriginsApiFp(this.configuration).internalAllowedOriginsAllGet(requestParameters.searchTerm, requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all the origins that have been allowed to send requests to the platform.
     * @param {AllowedOriginsApiInternalAllowedOriginsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalAllowedOriginsGet(requestParameters: AllowedOriginsApiInternalAllowedOriginsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AllowedOriginsApiFp(this.configuration).internalAllowedOriginsGet(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ApplicationApi - axios parameter creator
 */
export const ApplicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get the platform definition for the given domain
         * @param {string} [domain] the domain name to resolve
         * @param {string} [password] the domain password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveGet: async (domain?: string, password?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicationApi - functional programming interface
 */
export const ApplicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get the platform definition for the given domain
         * @param {string} [domain] the domain name to resolve
         * @param {string} [password] the domain password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveGet(domain?: string, password?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationPlatformResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveGet(domain, password, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicationApi.resolveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApplicationApi - factory interface
 */
export const ApplicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicationApiFp(configuration)
    return {
        /**
         * 
         * @summary get the platform definition for the given domain
         * @param {ApplicationApiResolveGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveGet(requestParameters: ApplicationApiResolveGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApplicationPlatformResponse> {
            return localVarFp.resolveGet(requestParameters.domain, requestParameters.password, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for resolveGet operation in ApplicationApi.
 */
export interface ApplicationApiResolveGetRequest {
    /**
     * the domain name to resolve
     */
    readonly domain?: string

    /**
     * the domain password
     */
    readonly password?: string
}

/**
 * ApplicationApi - object-oriented interface
 */
export class ApplicationApi extends BaseAPI {
    /**
     * 
     * @summary get the platform definition for the given domain
     * @param {ApplicationApiResolveGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resolveGet(requestParameters: ApplicationApiResolveGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ApplicationApiFp(this.configuration).resolveGet(requestParameters.domain, requestParameters.password, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlatformsApi - axios parameter creator
 */
export const PlatformsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get platforms query internal, doesn\'t join all the tables and has no admin permission.
         * @param {string} [platformIds] 
         * @param {string} [partnerIds] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPlatformsGet: async (platformIds?: string, partnerIds?: string, searchTerm?: string, isArchived?: boolean, offset?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/platforms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platformIds !== undefined) {
                localVarQueryParameter['platformIds'] = platformIds;
            }

            if (partnerIds !== undefined) {
                localVarQueryParameter['partnerIds'] = partnerIds;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the primary domain associated with a platform.
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPlatformsPlatformIdPrimaryDomainGet: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('internalPlatformsPlatformIdPrimaryDomainGet', 'platformId', platformId)
            const localVarPath = `/internal/platforms/{platformId}/primary-domain`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the primary domain associated with a platform.
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformsPlatformIdPrimaryDomainGet: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('platformsPlatformIdPrimaryDomainGet', 'platformId', platformId)
            const localVarPath = `/platforms/{platformId}/primary-domain`
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlatformsApi - functional programming interface
 */
export const PlatformsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlatformsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get platforms query internal, doesn\'t join all the tables and has no admin permission.
         * @param {string} [platformIds] 
         * @param {string} [partnerIds] 
         * @param {string} [searchTerm] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalPlatformsGet(platformIds?: string, partnerIds?: string, searchTerm?: string, isArchived?: boolean, offset?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminListPlatformResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalPlatformsGet(platformIds, partnerIds, searchTerm, isArchived, offset, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformsApi.internalPlatformsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the primary domain associated with a platform.
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalPlatformsPlatformIdPrimaryDomainGet(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalPlatformsPlatformIdPrimaryDomainGet(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformsApi.internalPlatformsPlatformIdPrimaryDomainGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the primary domain associated with a platform.
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async platformsPlatformIdPrimaryDomainGet(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.platformsPlatformIdPrimaryDomainGet(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformsApi.platformsPlatformIdPrimaryDomainGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlatformsApi - factory interface
 */
export const PlatformsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlatformsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get platforms query internal, doesn\'t join all the tables and has no admin permission.
         * @param {PlatformsApiInternalPlatformsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPlatformsGet(requestParameters: PlatformsApiInternalPlatformsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminListPlatformResponse> {
            return localVarFp.internalPlatformsGet(requestParameters.platformIds, requestParameters.partnerIds, requestParameters.searchTerm, requestParameters.isArchived, requestParameters.offset, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the primary domain associated with a platform.
         * @param {PlatformsApiInternalPlatformsPlatformIdPrimaryDomainGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPlatformsPlatformIdPrimaryDomainGet(requestParameters: PlatformsApiInternalPlatformsPlatformIdPrimaryDomainGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DomainResponse> {
            return localVarFp.internalPlatformsPlatformIdPrimaryDomainGet(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the primary domain associated with a platform.
         * @param {PlatformsApiPlatformsPlatformIdPrimaryDomainGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformsPlatformIdPrimaryDomainGet(requestParameters: PlatformsApiPlatformsPlatformIdPrimaryDomainGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DomainResponse> {
            return localVarFp.platformsPlatformIdPrimaryDomainGet(requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalPlatformsGet operation in PlatformsApi.
 */
export interface PlatformsApiInternalPlatformsGetRequest {
    /**
     * 
     */
    readonly platformIds?: string

    /**
     * 
     */
    readonly partnerIds?: string

    /**
     * 
     */
    readonly searchTerm?: string

    readonly isArchived?: boolean

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly size?: number
}

/**
 * Request parameters for internalPlatformsPlatformIdPrimaryDomainGet operation in PlatformsApi.
 */
export interface PlatformsApiInternalPlatformsPlatformIdPrimaryDomainGetRequest {
    /**
     * 
     */
    readonly platformId: string
}

/**
 * Request parameters for platformsPlatformIdPrimaryDomainGet operation in PlatformsApi.
 */
export interface PlatformsApiPlatformsPlatformIdPrimaryDomainGetRequest {
    /**
     * 
     */
    readonly platformId: string
}

/**
 * PlatformsApi - object-oriented interface
 */
export class PlatformsApi extends BaseAPI {
    /**
     * 
     * @summary Get platforms query internal, doesn\'t join all the tables and has no admin permission.
     * @param {PlatformsApiInternalPlatformsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalPlatformsGet(requestParameters: PlatformsApiInternalPlatformsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PlatformsApiFp(this.configuration).internalPlatformsGet(requestParameters.platformIds, requestParameters.partnerIds, requestParameters.searchTerm, requestParameters.isArchived, requestParameters.offset, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the primary domain associated with a platform.
     * @param {PlatformsApiInternalPlatformsPlatformIdPrimaryDomainGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalPlatformsPlatformIdPrimaryDomainGet(requestParameters: PlatformsApiInternalPlatformsPlatformIdPrimaryDomainGetRequest, options?: RawAxiosRequestConfig) {
        return PlatformsApiFp(this.configuration).internalPlatformsPlatformIdPrimaryDomainGet(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the primary domain associated with a platform.
     * @param {PlatformsApiPlatformsPlatformIdPrimaryDomainGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public platformsPlatformIdPrimaryDomainGet(requestParameters: PlatformsApiPlatformsPlatformIdPrimaryDomainGetRequest, options?: RawAxiosRequestConfig) {
        return PlatformsApiFp(this.configuration).platformsPlatformIdPrimaryDomainGet(requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RedirectsApi - axios parameter creator
 */
export const RedirectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get active redirects. (optionally provide a domain to which redirects should be scoped.)
         * @param {string} [domain] platform domain for which to return redirects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectsGet: async (domain?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/redirects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedirectsApi - functional programming interface
 */
export const RedirectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RedirectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get active redirects. (optionally provide a domain to which redirects should be scoped.)
         * @param {string} [domain] platform domain for which to return redirects.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redirectsGet(domain?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RedirectResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redirectsGet(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RedirectsApi.redirectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RedirectsApi - factory interface
 */
export const RedirectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RedirectsApiFp(configuration)
    return {
        /**
         * 
         * @summary get active redirects. (optionally provide a domain to which redirects should be scoped.)
         * @param {RedirectsApiRedirectsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redirectsGet(requestParameters: RedirectsApiRedirectsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<RedirectResponse>> {
            return localVarFp.redirectsGet(requestParameters.domain, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for redirectsGet operation in RedirectsApi.
 */
export interface RedirectsApiRedirectsGetRequest {
    /**
     * platform domain for which to return redirects.
     */
    readonly domain?: string
}

/**
 * RedirectsApi - object-oriented interface
 */
export class RedirectsApi extends BaseAPI {
    /**
     * 
     * @summary get active redirects. (optionally provide a domain to which redirects should be scoped.)
     * @param {RedirectsApiRedirectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public redirectsGet(requestParameters: RedirectsApiRedirectsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return RedirectsApiFp(this.configuration).redirectsGet(requestParameters.domain, options).then((request) => request(this.axios, this.basePath));
    }
}



